export default __webpack_public_path__ + "static/media/sigei.b5a48e82.png";